<template>
    <div v-cloak v-if="show" class="fixed bottom-0 left-0 w-full bg-gray-100 border-t border-gray-400 shadow-lg-t" class2="bg-white">
        <div class="relative text-center">
            <div class="flex flex-no-wrap whitespace-no-wrap justify-center items-center h-16">
                <div class="flex justify-center items-center mr-10">
                    <strong class="mr-1">Join {{ appName }}</strong>
                    to get alerts when products are restocked.
                </div>

                <div class="flex flex-no-wrap whitespace-no-wrap justify-center items-center">
                    <social-btn href="/register?email=1" brand="envelope" size="sm" class="mr-2">Signup with Email</social-btn>

                    <social-btn href="/auth/discord" brand="discord" size="sm" class="border mr-2">Signup with Discord</social-btn>

                    <social-btn href="/auth/google" brand="google" size="sm" class="border mr-2">Signup with Google</social-btn>
                </div>

                <button @click="close" type="button" class="ml-2 text-gray-600 hover:text-gray-700 py-1 px-2 focus:outline-none" class2="absolute top-0 right-0 z-10 mt-1 mr-1" title="Hide">
                    <i class="far fa-times fa-lg"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
// import HideableMixin from '../../mixins/hideable';

/**
 * @todo slide in after 1 second on the site? or as the user scrolls page?
 * @todo add analytics events
 */
export default {
    // mixins: [HideableMixin],

    data: () => ({
        show: true,
        cookieName: 'promo_signup'
    }),

    created() {
        if (this.mobile) {
            this.show = false;
        } else if (this.user) {
            this.show = false;
        } else {
            const value = this.getCookie(this.cookieName);
            if (value === 'false' || value === false) {
                this.show = false;
            }
        }
    },

    mounted() {},

    computed: {},

    methods: {
        close() {
            this.setCookie(this.cookieName, false, 365);

            this.show = false;
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
